exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".gvl-print-data{position:relative;padding-bottom:60px}.gvl-print-data #print-content{max-height:calc(100vh - 200px);overflow:auto;color:rgba(0,0,0,.87)}.gvl-print-data .btn-row{position:absolute;bottom:0;left:0;right:0;margin:0}", ""]);

